"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGenericMasterSchema = exports.createGenericMasterSchema = exports.genericMasterShape = void 0;
const zod_1 = require("zod");
exports.genericMasterShape = {
    genericCode: zod_1.z.string().min(1).max(30).optional(),
    name: zod_1.z.string().min(1).max(255),
    atcCode: zod_1.z.string().max(20).optional(),
    therapeuticClassId: zod_1.z.string().uuid().optional(),
    description: zod_1.z.string().optional(),
};
exports.createGenericMasterSchema = zod_1.z.object(exports.genericMasterShape);
exports.updateGenericMasterSchema = exports.createGenericMasterSchema.partial();
//# sourceMappingURL=generic-master.schema.js.map